import React, { Component } from 'react';
import Handle from './Handle';
import Rheostat from 'rheostat';
// import 'rheostat/initialize';

import './styles.css';

import 'rheostat/css/rheostat.css';
// import 'react-dates/lib/css/_datepicker.css';

import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';
import cssInterface from 'react-with-styles-interface-css';
import RheostatDefaultTheme from 'rheostat/lib/themes/DefaultTheme';
// import ReactDatesDefaultTheme from 'react-dates/lib/theme/DefaultTheme';
import CommonButton from '../common/CommonButton';
import {
  PriceRangeContainer,
  PriceRangeText,
  PriceFilterContainer,
} from './styles';

ThemedStyleSheet.registerInterface(cssInterface);
ThemedStyleSheet.registerTheme({
  ...RheostatDefaultTheme,
  // ...ReactDatesDefaultTheme,
});

class PriceFilterV70 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxPrice: Math.max(...this.props.prices),
      lowerBound: this.props.lowerBound || null,
      upperBound: this.props.upperBound || null,
      prices: this.props.prices,
      count: this.props.prices.length,
      histoValues: [],
    };

    this.config = {
      buckets: 20,
      round_step: 5,
    };

    // Calculate steps for the histogram
    this.state.maxPrice = Math.max(...this.state.prices);

    let step = this.state.maxPrice / this.config.buckets;
    step = Math.ceil(step / this.config.round_step) * this.config.round_step;

    this.state.step = step;
    this.state.lowerBound = this.props.lowerBound || 0;
    this.state.startingLowerBound = this.state.lowerBound;

    this.state.upperBound =
      this.props.upperBound || this.state.step * this.config.buckets;
    this.state.startingUpperBound = this.state.upperBound;

    let histo_values = [];
    for (let i = 0; i < this.config.buckets; i++) {
      histo_values.push(0);
    }

    for (let i = 0; i < this.state.prices.length; i++) {
      let idx = this.state.prices[i] / this.state.step;
      idx = Math.min(Math.floor(idx), this.config.buckets - 1);
      histo_values[idx] += 1;
    }
    this.state.histoValues = histo_values;

    this.temp = {
      sliderStartLowerBound: this.state.lowerBound,
      sliderStartUpperBound: this.state.upperBound,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.lowerBound !== this.state.lowerBound ||
      prevState.upperBound !== this.state.upperBound
    ) {
      if (this.props.onChanging) this.props.onChanging(this.state);
    }
  }

  handleSliderUpdate = (sliderState) => {
    this.setState({
      lowerBound: sliderState.values[0],
      upperBound: sliderState.values[1],
    });
  };

  handleApplyValues = (e) => {
    if (this.props.onApplyValues) this.props.onApplyValues(this.state);
  };

  validateNewPosition = (data) => {
    let count = 0;
    let lowerBound = data.values[0];
    let upperBound = data.values[1];
    for (let i = 0; i < this.state.prices.length; i++) {
      if (
        this.state.prices[i] >= lowerBound &&
        this.state.prices[i] <= upperBound
      ) {
        count += 1;
      }
    }

    if (count === 0) {
      this.setState({
        lowerBound: this.temp.sliderStartLowerBound,
        upperBound: this.temp.sliderStartUpperBound,
      });
    } else {
      this.props.onChangingEligible && this.props.onChangingEligible(count);
      this.setState(
        {
          lowerBound: lowerBound,
          upperBound: upperBound,
          count: count,
        },
        () => {
          this.temp = {
            sliderStartLowerBound: this.state.lowerBound,
            sliderStartUpperBound: this.state.upperBound,
          };
          if (this.onChanged) this.onChanged(this.state);
        }
      );
    }
  };

  render() {
    return (
      <PriceFilterContainer>
        <Histogram values={this.state.histoValues} />
        <Rheostat
          min={0}
          max={this.state.step * this.config.buckets}
          values={[this.state.lowerBound, this.state.upperBound]}
          onValuesUpdated={this.handleSliderUpdate}
          onChange={this.validateNewPosition}
          handle={Handle}
        />

        <PriceRangeContainer>
          <PriceRangeText>Price range:</PriceRangeText> {this.state.lowerBound}{' '}
          - ${this.state.upperBound}
        </PriceRangeContainer>
        <CommonButton width={300} onClick={this.handleApplyValues}>
          Use This Range
        </CommonButton>
      </PriceFilterContainer>
    );
  }
}

class Histogram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: props.values,
      max_value: Math.max(...props.values),
    };
  }

  render() {
    return (
      <div className='histogram'>
        {this.state.values.map((val, index) => (
          <div
            className='bar'
            key={index}
            style={{
              height: (100 * val) / this.state.max_value + '%',
            }}
          >
            {' '}
          </div>
        ))}
      </div>
    );
  }
}

export default PriceFilterV70;
